<template>
    <div class="free-consultation">
        <el-backtop :bottom="100">
            <div class="up"   >
                <div class="consultation-box" @click.stop="" @mouseenter="handleMouseEnter" @mouseleave="handleMouseLeave">
                     <img src="../../assets/message.png"  style="width: 24px; height: 24px;"/>
                     <div style="height: 3px;"></div>
                     <div :class="[{consultation:true},{active: isTransferIn}]">免费咨询</div>
                </div>
                <div style="height: 10px;"></div>
                <img src="../../assets/up-yes.png" @click="restore" v-if="isUp" @mouseleave="handleMouseLeaveUp" style="width: 65px; height: 65px;"/>
                <img src="../../assets/up-no.png"  v-else @mouseenter="handleMouseEnterUp" style="width: 65px; height: 65px;"/>
                <img src="../../assets/consultation-qr-code.png" v-show="isTransferIn" class="qr-code"/>
            </div>
        </el-backtop>
    </div>
</template>

<script>
export default {
    name: 'free-consultation',
    data() {
        return {
            isTransferIn: false,
            isUp: false,

        }
    },
    methods: {

        restore(){
            this.isTransferIn = false;
            this.isUp = false;
        },

        handleMouseEnterUp(){
            this.isUp = true;
        },
        handleMouseLeaveUp(){
             this.isUp = false;
        },

        handleMouseEnter(){
            this.isTransferIn = true;
        },
        handleMouseLeave(){
            this.isTransferIn = false;
        }
    }
}
</script>

<style lang="scss" scoped>
   .free-consultation{
      .up{
        height: 229px;
        width: 52px;
        display:flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .qr-code{
            width: 163px;
            height: 154px;
            position:absolute;
            bottom: 18px;
            left: -173px;
        }
        .consultation-box{
            width: 52px;
            height: 154px;
            background: #FFFFFF;
            box-shadow: 0px 2px 6px 0px rgba(213,213,213,0.5);
            border-radius: 26px;
            display:flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .consultation{
                width: 17px;
                height: 88px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                line-height: 22px;
                text-align: right;
                font-style: normal;
                color: #171A1D;
            }
            .active{
                color: #FF6E00;
            }
        }
      }
   }
</style>


// WEBPACK FOOTER //
// src/components/FreeConsultation/freeConsultation.vue